import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';

interface LayoutState {
  csiOpen: boolean;
  csiAction: (rating: number, comment: string) => void;
  csiRedirectPage: string;
}

const LayoutContext = createContext<{
  layoutState: LayoutState;
  setLayoutState: Dispatch<SetStateAction<LayoutState>>;
} | null>(null);

export const LayoutProvider = ({ children }: any) => {
  const [layoutState, setLayoutState] = useState({
    csiOpen: false,
    csiAction: (rating: number, comment: string) => {},
    csiRedirectPage: 'home-page',
  });

  return (
    <LayoutContext.Provider value={{ layoutState, setLayoutState }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayoutContext = () => {
  return useContext(LayoutContext);
};
